/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Duplicate_FileInputs */

const en_issue_duplicate_file = /** @type {(inputs: Issue_Duplicate_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chosen twice`)
};

/**
* | output |
* | --- |
* | "chosen twice" |
*
* @param {Issue_Duplicate_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_duplicate_file = /** @type {((inputs?: Issue_Duplicate_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Duplicate_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_duplicate_file(inputs)
});